export default __webpack_public_path__ + "static/media/pro_4.e8f1e8c7.jpg";